import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {
  IAgency,
  IProduct,
  IRole,
  ITag,
  IUser,
  ProductFilterDto,
  TagFilterDto,
  UserFilterDto,
} from 'admiral-core';
import { ProductApi } from '@/services/ProductApi';
import { UserApi } from '@/services/UserApi';
import { AgencyApi } from '@/services/AgencyApi';
import { TagApi } from '@/services/TagApi';

export enum DataAction {
  fetchProducts = 'fetchProducts',
  fetchUsers = 'fetchUsers',
  fetchRoles = 'fetchRoles',
  fetchTags = 'fetchTags',
  fetchAgency = 'fetchAgency',
}

export interface DataState {
  users: IUser[];
  products: IProduct[];
  roles: IRole[];
  tags: ITag[];
  agency: IAgency;
}

@Module({ namespaced: true, name: 'DataModule' })
export class DataModule extends VuexModule<DataState> {
  users: IUser[] = [];
  products: IProduct[] = [];
  roles: IRole[] = [];
  tags: ITag[] = [];

  agency: IAgency | null = null;

  @MutationAction({ mutate: ['products'], rawError: true })
  async [DataAction.fetchProducts](filter: ProductFilterDto) {
    const result = await ProductApi.getProducts(filter);
    return { products: result.data };
  }

  @MutationAction({ mutate: ['users'], rawError: true })
  async [DataAction.fetchUsers](filter: UserFilterDto) {
    const result = await UserApi.getUsers(filter);
    return { users: result.data };
  }

  @MutationAction({ mutate: ['roles'], rawError: true })
  async [DataAction.fetchRoles]() {
    const result = await UserApi.getUserRoles();
    return { roles: result.data };
  }

  @MutationAction({ mutate: ['tags'], rawError: true })
  async [DataAction.fetchTags](filter?: TagFilterDto) {
    const result = await TagApi.getTags(filter);
    return { tags: result.data };
  }

  @MutationAction({ mutate: ['agency'], rawError: true })
  async [DataAction.fetchAgency]() {
    const result = await AgencyApi.getAgency();
    return { agency: result.data };
  }

  @Mutation
  updateTags(tags: ITag[]) {
    this.tags = tags;
  }
}
